import { css } from '@emotion/react';
import { Theme } from '@mui/material';

export const styles = {
  draggableContainer: (theme: Theme) => css`
    position: absolute;
    font-size: 13px;
    font-weight: 100;
    padding: 6px ${theme.spacing(2)};
    width: 100%;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    text-align: center;
  `,
  floatMessageContainer: css`
    position: absolute;
    top: 0;
    width: 100%;
    margin: 0;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #fff;
    background-color: rgba(17, 17, 17, 0.7);
    z-index: 999;
    pointer-events: none;
  `,
  floatMessageColorDot: (color: string) => css`
    width: 8px;
    height: 8px;
    background-color: ${color};
    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.4);
    transform: rotate(45deg);
    flex-shrink: 0;
  `
};
